<template>
  <div id="badend">
    <div class="wrap">
      <div class="inr">
        <div class="img1"><img :src="`${publicPath}img/common/badend_img01.png`"></div>
        <div class="img2"><img :src="`${publicPath}img/common/badend_img02.gif`"></div>
        <div class="img3"><img :src="`${publicPath}img/common/badend_img03.png`"></div>
      </div>
      <div class="arrow" :style="arrowStyle"></div>
    </div>
  </div>
</template>

<script>
  import _$ from 'jquery'

  export default {
    name: 'Result_Badend',
    data() {
      return {
        publicPath: process.env.BASE_URL,
        arrowStyle: {
          backgroundImage: 'url(./img/common/yellow_arw.png'
        },
        timer: null
      }
    },
    created() {
      this.timer = setInterval(function(){
        _$('#badend .arrow').toggle()
      }.bind(this), 500)
    },
    destroyed() {
      clearInterval(this.timer)
    }
  }
</script>

<style lang="scss" scoped>
  #badend {
    background-color: #000;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;

    .wrap {
      width: 100%;
      height: 100%;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      pointer-events: none;
    }

    .arrow {
      background-repeat: no-repeat;
      background-size: contain;
      width: toVW(28);
      height: toVW(21);
      position: absolute;
      bottom: toVW(30);
      left: calc((100% - 3.73vw) / 2);
    }

    .inr {
      .img1 {
        width: toVW(563);
        height: auto;
        margin: 0 auto toVW(69);
        pointer-events: none;
      }

      .img2 {
        width: toVW(497);
        height: auto;
        margin: 0 auto toVW(47);
        pointer-events: none;
      }

      .img3 {
        width: toVW(563);
        height: auto;
        margin: 0 auto;
        pointer-events: none;
      }
    }
  }
</style>
